import { render, staticRenderFns } from "./ResearchBarInCellPlot.vue?vue&type=template&id=13476208"
import script from "./ResearchBarInCellPlot.vue?vue&type=script&lang=js"
export * from "./ResearchBarInCellPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13476208')) {
      api.createRecord('13476208', component.options)
    } else {
      api.reload('13476208', component.options)
    }
    module.hot.accept("./ResearchBarInCellPlot.vue?vue&type=template&id=13476208", function () {
      api.rerender('13476208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchBarInCellPlot.vue"
export default component.exports